import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import i18n from 'i18next';

import NestedList from '../components/nestedList';

const NestedListContainer = createReactClass({
  getDefaultProps() {
    return {
      bodyClassName: '',
      children: null,
      className: '',
      expandedClassName: '',
      header: null,
      headerClassName: '',
      headerPrepend: null,
      hasToggle: true,
      id: '',
      initialExpandedIds: [],
      isExpanded: false,
      toggleAriaLabel: '',
      toggleButtonSize: 'small',
      toggleClassName: '',
      toggleIconSize: 18,
      toggleType: 'triangle',
    };
  },

  getInitialState() {
    return { expandedIds: this.props.initialExpandedIds };
  },

  handleToggleClick(id) {
    this.setState(({ expandedIds }) => ({
      expandedIds: expandedIds.includes(id)
        ? expandedIds.filter((list) => list !== id)
        : [...expandedIds, id],
    }));

    this.props.onToggleClick?.(id);
  },

  render() {
    const {
      bodyAriaLabel,
      bodyClassName,
      children,
      className,
      expandedClassName,
      header,
      headerClassName,
      headerPrepend,
      hasToggle,
      id,
      isExpanded,
      toggleAriaLabel,
      toggleButtonSize,
      toggleClassName,
      toggleIconSize,
      toggleType,
    } = this.props;

    return (
      <NestedList
        bodyAriaLabel={bodyAriaLabel}
        bodyClassName={bodyClassName}
        className={className}
        expandedClassName={expandedClassName}
        hasToggle={hasToggle}
        header={header}
        headerClassName={headerClassName}
        headerPrepend={headerPrepend}
        id={id}
        isExpanded={isExpanded || this.state.expandedIds.includes(id)}
        onToggleClick={this.handleToggleClick}
        toggleAriaLabel={
          toggleAriaLabel || i18n.t('toggle-aria-label-name', { name: bodyAriaLabel })
        }
        toggleButtonSize={toggleButtonSize}
        toggleClassName={toggleClassName}
        toggleIconSize={toggleIconSize}
        toggleType={toggleType}
      >
        {children}
      </NestedList>
    );
  },
});

NestedListContainer.propTypes = {
  bodyClassName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  expandedClassName: PropTypes.string,
  header: PropTypes.node,
  headerClassName: PropTypes.string,
  headerPrepend: PropTypes.node,
  hasToggle: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  initialExpandedIds: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ])),
  isExpanded: PropTypes.bool,
  bodyAriaLabel: PropTypes.string,
  toggleAriaLabel: PropTypes.string,
  toggleButtonSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  toggleClassName: PropTypes.string,
  toggleIconSize: PropTypes.number,
  toggleType: PropTypes.oneOf(['caret', 'triangle']),
};

export default NestedListContainer;
